import { observer } from 'mobx-react-lite'
import React, { Fragment, useMemo } from 'react'
import { Building } from 'react-bootstrap-icons'

export default observer(function Cities({ currentAuthentication }) {

  const city = useMemo(() => currentAuthentication?.audience_information?.detailed_audience_stats?.city, [currentAuthentication?.audience_information?.detailed_audience_stats?.city])
  const percentageSum = useMemo(() => city && (city.reduce((result, { percentage }) => result + percentage, 0) * 100).toFixed(2), [city])

  if(['tiktok', 'youtube'].includes(currentAuthentication.provider)) return

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-4">
      <div className="w-1/4 mb-4 flex items-center p-4">
        <div className="text-gray-400 dark:text-gray-500 mr-2">
          <Building />
        </div>
        <p className="font-bold text-xl dark:text-white">Audience Cities</p>
      </div>
      <div className="grid grid-cols-2">
        {city && [...Array(5)].map((_, i) => (
          <Fragment key={i}>
            <div className="flex justify-between border-1 border-gray-200 dark:border-rb-dark-mode-lighter">
              <p className="p-4 font-bold dark:text-white">{city[i]?.name}</p>
              <p className="p-4 font-bold dark:text-white">{(city[i]?.percentage * 100).toFixed(2)}%</p>
            </div>
            <div className="flex justify-between border-1 border-gray-200 dark:border-rb-dark-mode-lighter">
              <p className="p-4 font-bold dark:text-white">{city[i + 5]?.name}</p>
              <p className="p-4 font-bold dark:text-white">{(city[i + 5]?.percentage * 100).toFixed(2)}%</p>
            </div>
          </Fragment>
        ))
        }
      </div>
      <div className="flex items-center p-4">
        <p className="font-bold text-gray-300 dark:text-gray-400 mr-2">Total of visible cities</p>
        <p className="font-bold dark:text-white">{percentageSum}%</p>
      </div>
    </div>
  )
})